import { MutationTree } from "vuex";
import { DataImplementationState, DataImplementation, DataSample, Message } from "./model";

const mutations: MutationTree<DataImplementationState> = {
  setDataImplementations(state, dataImplementations: DataImplementation[]) {
    state.dataImplementations = dataImplementations
  },
  setDataImplementation(state, dataImplementation: DataImplementation) {
    state.dataImplementation = dataImplementation
  },
  addDataImplementation(state, dataImplementation: DataImplementation) {
    state.dataImplementations.push(dataImplementation)
  },
  updateDataImplementation(state, dataImplementation: DataImplementation) {
    const index = state.dataImplementations.findIndex(c => c.id === dataImplementation.id);
    if(index !== -1) {
      state.dataImplementations.splice(index, 1, dataImplementation);
    }
  },
  replaceDataImplementation(state, dataImplementation: DataImplementation) {
    const index = state.dataImplementations.findIndex(c => c.id === dataImplementation.id);
    if (index !== -1) {
      state.dataImplementations.splice(index, 1, dataImplementation);
    } else {
      state.dataImplementations.push(dataImplementation);
    }
  },
  deleteDataImplementation(state, id: string) {
    state.dataImplementations = state.dataImplementations.filter(dataImplementation => dataImplementation.id !== id)
  },
  setMessages(state, messages: Message[]) {
    state.messages = messages
  }
}

export default mutations;
